const clipsContent = (overflow: string) => /^(auto|scroll|hidden|clip)$/.test(overflow);

export const isTodoOnScreen = (element: HTMLElement | null): boolean => {
  if (!element || document.visibilityState === 'hidden') {
    return false;
  }

  const rect = element.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) {
    return false;
  }

  let left = Math.max(0, rect.left);
  let right = Math.min(window.innerWidth, rect.right);
  let top = Math.max(0, rect.top);
  let bottom = Math.min(window.innerHeight, rect.bottom);
  let ancestor = element.parentElement;

  while (ancestor) {
    const style = window.getComputedStyle(ancestor);
    const bounds = ancestor.getBoundingClientRect();
    if (clipsContent(style.overflowX || style.overflow)) {
      left = Math.max(left, bounds.left);
      right = Math.min(right, bounds.right);
    }
    if (clipsContent(style.overflowY || style.overflow)) {
      top = Math.max(top, bounds.top);
      bottom = Math.min(bottom, bounds.bottom);
    }
    ancestor = ancestor.parentElement;
  }

  // Keep the existing 50px vertical visibility requirement; also exclude
  // rows that are still sliding into view from another tab.
  if (right - left < rect.width - 1 || bottom - top < Math.min(50, rect.height)) {
    return false;
  }

  if (typeof document.elementFromPoint === 'function') {
    const foreground = document.elementFromPoint((left + right) / 2, (top + bottom) / 2);
    if (!foreground || !element.contains(foreground)) {
      return false;
    }
  }

  return true;
};



// WEBPACK FOOTER //
// ./src/components/todo/todoVisibility.ts